import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { __Currency, __EventDispatcher, __Lang } from "../../../_core/core";
import { store } from "../../../_core/core.Store";
import { EventClass, EventType } from "../../config/Events";
import PRIZES from "../../config/Prizes";

import "../ticket-selector/TicketSelector.styles.css";

const BetTicket = (_props?: any) => {
  const [currentPrize, setCurrentPrize] = useState<any>();

  const formatMatches = (_arr: number[]) => {
    if (_arr.length === 1) return _arr[0];

    let maxArray = Math.max(..._arr),
      minArray = Math.min(..._arr);
    return minArray + "-" + maxArray;
  };
  /**
   *
   * @param _selectedNumbers
   * @returns
   */
  const getCurrentPrize = (_selectedNumbers: number) => {
    if (PRIZES.has(_selectedNumbers)) {
      let _currentPrize = PRIZES.get(_selectedNumbers);
      let _drawedNumbers: any = store.getState().game.GAMEPLAY.drawedNumbers;
      let _currentTicketNumbers = Object.keys(_props.GAMEPLAY.selectedNumbers);

      let matches = _currentTicketNumbers.filter((_e) => {
        return _drawedNumbers.includes(parseInt(_e));
      });

      let noOfMatches = -1;
      if (_drawedNumbers.length) {
        noOfMatches = matches.length;
      }

      let _itemsToDisplay = _currentPrize ? [..._currentPrize?.items] : [];

      _itemsToDisplay.forEach((prize, index) => {
        if (prize.matches.indexOf(noOfMatches) !== -1) {
          __EventDispatcher.dispatch(
            EventClass.GAMEPLAY,
            EventType.GAMEPLAY.PRIZE_CHANGE,
            {
              prizeIndex: index,
            }
          );
          return;
        }
      });
      const lState = store.getState();

      const getPrizeValue = (prize: any) => {
        const currency = lState.game.SESSION_DATA.currency.code;
        let _prize = _props.STATUS_DATA.bet * prize.winMultiplier;

        if (currency === "AUD" && _prize >= 10000000) {
          _prize = 10000000;
        }
        return _prize;
      };

      return (
        <>
          {_itemsToDisplay.map((prize, i) => (
            <span
              className={"btn-weird prize-item prize-" + i}
              key={`Prize${i}`}
            >
              {__Lang.replace("n:play.match2", {
                value: formatMatches(prize.matches),
              })}
              : &nbsp;
              {prize.lose
                ? __Currency.format(0)
                : __Currency.format(getPrizeValue(prize))}
            </span>
          ))}
        </>
      );
    }
    return (
      <div className="empty-prizes-label">
        {__Lang.translate("n:play.playDisclaimer")}
      </div>
    );
  };

  const onEventDispatched = (
    _eventClass: EventClass,
    _eventType: string,
    _eventPayload: any
  ) => {
    if (_eventClass !== EventClass.GAMEPLAY) return false;

    switch (_eventType) {
      case EventType.GAMEPLAY.PRIZE_CHANGE:
        setTimeout(() => {
          let _allPrizes = document.querySelectorAll(".prize-item");
          _allPrizes.forEach((prize) => {
            prize.classList.remove("active");
          });

          let _el = document.querySelector(
            ".prize-" + _eventPayload.prizeIndex
          );
          // console.log('prize is change', _eventPayload, document.querySelector('.prize-' + _eventPayload.prizeIndex));

          _el?.classList.add("active");
        }, 1800);

        __EventDispatcher.removeListener(EventClass.GAMEPLAY, () => {}, this);
        break;
    }
  };

  //on current prize changed
  useEffect(() => {
    let _selectedN = Object.values(_props.GAMEPLAY.selectedNumbers).filter(
      (_el: any) => {
        return _el.isConfirmed === true || _el.isSelected;
      }
    ).length;

    setCurrentPrize(getCurrentPrize(_selectedN));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    _props.GAMEPLAY.selectedNumbers,
    _props.GAMEPLAY.drawedNumbers,
    _props.STATUS_DATA.bet,
  ]);

  //on mounted
  useEffect(() => {
    __EventDispatcher.addListener(EventClass.GAMEPLAY, onEventDispatched, this);
  }, []);

  return (
    <div className="ticket-purchase-options-container">
      <div className="option-title text-center">
        {__Lang.translate("n:play.win")}
      </div>
      <div className="options-container prize-table-ticker">{currentPrize}</div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY,
    STATUS_DATA: state.game.STATUS_DATA,
  };
};

export default connect(mapStateToProps, {})(BetTicket);
